import {getCSRF_Token} from "@/fonction/logConnection";
import {Contrat} from "@/ts/contrat";
import {updateKpi} from "@/ts/kpi";

import {callApi} from "./_callApi";

// Appel pour demander la modification de la valeur d'un KPI par un adhérent.
export async function PostEvenement(
  API: string | undefined,
  body: updateKpi,
  contremarque: string | null = null,
  kpiId: number
): Promise<Contrat> {
  try {
    if (!API) {
      throw new Error("API is not provided.");
    }
    const reponse = await callApi(
      `${API}/api/coact/v1/evenements`,
      "POST",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
        "X-Coact-Contremarque": contremarque,
      },
      "include",
      body
    );
    // si l'appel passe on retire les valeurs du local storage
    localStorage.removeItem(`kpi_${kpiId}_newValue`);
    localStorage.removeItem(`kpi_${kpiId}_commentaire`);
    return reponse as Contrat;
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function DeleteEvenement(
  API: string | undefined,
  evenementId: number,
  contremarque?: string
): Promise<void> {
  try {
    if (!API) {
      throw new Error("API is not provided.");
    }
    await callApi(
      `${API}/api/coact/v1/evenements/${evenementId}`,
      "DELETE",
      {
        ...(contremarque ? {"X-Coact-Contremarque": contremarque} : {}),
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include",
      {},
      false,
      false
    );
  } catch (error: any) {
    throw new Error(error?.message);
  }
}
